var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asc Brower"},[_c('div',{staticClass:"btncenter"},[_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.comeToCode()}}},[_vm._v("Code")]),_vm._v(" "),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.comeToBlockly()}}},[_vm._v("Blockly")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e469a988","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chooseMode.vue
// module id = 497
// module chunks = 0